/* 
Scaffolded code: this code was scaffolded by the code generator, feel free to change it
Template: ViewModel.cst
 */
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  CardLinkProps,
  CardLinkViewModelBase,
} from 'src/store/generated/card-link-record.generated';
import { CardLinkEntityFetchService } from 'src/store/generated/client-sync.generated';

export class CardLinkViewModel extends CardLinkViewModelBase {
  constructor(props: CardLinkProps) {
    super(props);
  }
}

@Injectable({ providedIn: 'root' })
export class CardLinkViewModelService {
  constructor(private readonly _cardLinkEntityFetchService: CardLinkEntityFetchService) {}

  getById(id: string): Observable<CardLinkViewModel | undefined> {
    return this._cardLinkEntityFetchService.getById(id).pipe(
      map((cardLink) => {
        if (cardLink == null) {
          return undefined;
        }
        return new CardLinkViewModel(cardLink);
      }),
    );
  }
}
